import React, { createContext, useState, useContext, useEffect } from "react";
import {
  getUser,
  login as apiLogin,
  logout as apiLogout,
  signup as apiSignup,
} from "../api/client";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const checkAuth = async () => {
      try {
        const userData = await getUser();
        if (isMounted) {
          setUser(userData);
        }
      } catch (error) {
        if (isMounted) {
          setUser(null);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    checkAuth();

    return () => {
      isMounted = false;
    };
  }, []);

  const signup = async (data) => {
    const response = await apiSignup(data);
    setUser(response.user);
    return response;
  };

  const login = async (data) => {
    const response = await apiLogin(data);
    setUser(response.user);
    return response;
  };

  const logout = async () => {
    await apiLogout();
    setUser(null);
  };

  const value = {
    user,
    loading,
    signup,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
